/* Lamisah product page: gallery dots, variant picker, quantity, share link,
   full-screen zoom. Add to bag posts a normal /cart/add form, which the
   store's cart drawer picks up and opens. */
(function () {
  'use strict';

  function qs(sel, el) { return (el || document).querySelector(sel); }
  function qsa(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  function money(cents, el) {
    var fmt = el.getAttribute('data-money-format') || (window.LM && window.LM.moneyFormat) || '{{amount}}';
    var trim = el.getAttribute('data-trim') === 'true';
    if (window.LM && window.LM.formatMoney) return window.LM.formatMoney(cents, fmt, trim);
    return (cents / 100).toFixed(2);
  }

  function Pdp(el) {
    this.el = el;
    var json = qs('[data-lm-product-json]', el);
    try { this.product = json ? JSON.parse(json.textContent) : null; } catch (e) { this.product = null; }
    this.gallery = qs('[data-lm-gallery]', el);
    this.dots = qsa('[data-lm-gallery-dots] span', el);
    this.zoom = qs('[data-lm-zoom]', el);
    this.bind();
    this.paintAvailability();
  }

  Pdp.prototype.bind = function () {
    var self = this;
    var el = this.el;

    if (this.gallery && this.dots.length) {
      var t;
      this.gallery.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var w = self.gallery.clientWidth || 1;
          var i = Math.round(self.gallery.scrollLeft / w);
          self.dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        }, 40);
      }, { passive: true });
    }

    el.addEventListener('change', function (e) {
      if (e.target.matches('[data-lm-opt]')) self.onOptionChange();
    });

    el.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-lm-qty-minus]')) || (t = e.target.closest('[data-lm-qty-plus]'))) {
        var box = t.closest('[data-lm-qty]');
        var input = qs('[data-lm-qty-input]', box);
        var v = parseInt(input.value, 10) || 1;
        v = t.hasAttribute('data-lm-qty-plus') ? v + 1 : Math.max(1, v - 1);
        input.value = v;
        return;
      }
      if ((t = e.target.closest('[data-lm-copy]'))) {
        var url = t.getAttribute('data-lm-copy');
        var msg = qs('[data-lm-copy-msg]', t.closest('.lm-share'));
        var done = function () {
          if (!msg) return;
          msg.hidden = false;
          setTimeout(function () { msg.hidden = true; }, 2200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, done);
        else {
          var ta = document.createElement('textarea');
          ta.value = url;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (err) { /* noop */ }
          ta.remove();
          done();
        }
        return;
      }
      if ((t = e.target.closest('[data-lm-zoom-open]')) && self.zoom) {
        e.preventDefault();
        self.openZoom(parseInt(t.getAttribute('data-lm-zoom-open'), 10) || 0);
        return;
      }
      if (e.target.closest('[data-lm-zoom-close]')) { self.closeZoom(); return; }
      if (e.target.closest('[data-lm-zoom-prev]')) { self.stepZoom(-1); return; }
      if (e.target.closest('[data-lm-zoom-next]')) { self.stepZoom(1); return; }
      var zimg = e.target.closest('.lm-zoom__slide img');
      if (zimg) zimg.parentElement.classList.toggle('is-zoomed');
    });

    document.addEventListener('keydown', function (e) {
      if (!self.zoom || self.zoom.hidden) return;
      if (e.key === 'Escape') self.closeZoom();
      if (e.key === 'ArrowRight') self.stepZoom(1);
      if (e.key === 'ArrowLeft') self.stepZoom(-1);
    });
  };

  Pdp.prototype.selected = function () {
    var vals = [];
    qsa('[data-lm-opt]:checked', this.el).forEach(function (r) {
      vals[parseInt(r.getAttribute('data-lm-opt'), 10)] = r.value;
    });
    return vals;
  };

  Pdp.prototype.findVariant = function (vals) {
    if (!this.product) return null;
    return this.product.variants.find(function (v) {
      return v.options.every(function (o, i) { return vals[i] === undefined || vals[i] === o; });
    }) || null;
  };

  Pdp.prototype.paintAvailability = function () {
    if (!this.product || !this.product.variants || this.product.variants.length < 2) return;
    var self = this;
    var vals = this.selected();
    qsa('[data-lm-opt]', this.el).forEach(function (input) {
      var idx = parseInt(input.getAttribute('data-lm-opt'), 10);
      var test = vals.slice();
      test[idx] = input.value;
      var match = self.product.variants.find(function (v) {
        return v.options.every(function (o, i) { return test[i] === undefined || test[i] === o; });
      });
      var label = input.closest('.lm-pdp__ovalue');
      if (label) label.classList.toggle('is-unavailable', !match || !match.available);
    });
  };

  Pdp.prototype.onOptionChange = function () {
    var el = this.el;
    var vals = this.selected();
    vals.forEach(function (v, i) {
      var out = qs('[data-lm-oval="' + i + '"]', el);
      if (out) out.textContent = v;
    });
    var variant = this.findVariant(vals);
    var atc = qs('[data-lm-atc]', el);
    var idInput = qs('[data-lm-variant-id]', el);

    if (!variant) {
      if (atc) { atc.disabled = true; atc.textContent = atc.getAttribute('data-label-na'); }
      this.paintAvailability();
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (atc) {
      atc.disabled = !variant.available;
      atc.textContent = variant.available ? atc.getAttribute('data-label-add') : atc.getAttribute('data-label-sold');
    }

    var now = qs('[data-lm-now]', el);
    var was = qs('[data-lm-was]', el);
    var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
    var pct = sale ? Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) : 0;
    if (now) { now.textContent = money(variant.price, el); now.classList.toggle('is-sale', !!sale); }
    if (was) { was.hidden = !sale; if (sale) was.textContent = money(variant.compare_at_price, el); }
    // every "% Off" mark: the gallery badge and the optional one beside the price
    Array.prototype.forEach.call(el.querySelectorAll('[data-lm-off]'), function (off) {
      off.hidden = !(sale && pct > 0);
      if (sale) off.textContent = off.textContent.replace(/^\s*\d+%/, pct + '%');
    });
    var skuBox = qs('[data-lm-sku-box]', el);
    var sku = qs('[data-lm-sku]', el);
    if (skuBox && sku) { sku.textContent = variant.sku || ''; skuBox.hidden = !variant.sku; }

    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', variant.id);
      window.history.replaceState(window.history.state, '', u.toString());
    } catch (err) { /* noop */ }

    if (variant.media_id && this.gallery) {
      var fig = qs('[data-lm-media="' + variant.media_id + '"]', this.gallery);
      if (fig && window.matchMedia('(max-width: 768px)').matches) {
        this.gallery.scrollTo({ left: fig.offsetLeft, behavior: 'smooth' });
      }
    }
    this.paintAvailability();
  };

  Pdp.prototype.openZoom = function (index) {
    var z = this.zoom;
    var track = qs('[data-lm-zoom-track]', z);
    qsa('img[data-src]', z).forEach(function (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); });
    z.hidden = false;
    if (window.LM && window.LM.lock) window.LM.lock();
    var slide = qs('.lm-zoom__slide[data-index="' + index + '"]', z) || qs('.lm-zoom__slide', z);
    if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
    var close = qs('[data-lm-zoom-close]', z);
    if (close) close.focus({ preventScroll: true });
  };
  Pdp.prototype.closeZoom = function () {
    if (!this.zoom || this.zoom.hidden) return;
    this.zoom.hidden = true;
    qsa('.lm-zoom__slide.is-zoomed', this.zoom).forEach(function (s) { s.classList.remove('is-zoomed'); });
    if (window.LM && window.LM.unlock) window.LM.unlock();
  };
  Pdp.prototype.stepZoom = function (dir) {
    var track = qs('[data-lm-zoom-track]', this.zoom);
    var w = track.clientWidth || 1;
    var i = Math.round(track.scrollLeft / w) + dir;
    var n = track.children.length;
    if (i < 0) i = n - 1;
    if (i >= n) i = 0;
    track.scrollTo({ left: i * w, behavior: 'smooth' });
  };

  function boot(scope) {
    qsa('[data-lm-pdp]', scope).forEach(function (el) {
      if (!el.__lmPdp) el.__lmPdp = new Pdp(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
